import { create } from 'zustand'

export type ThemeMode = 'light' | 'dark'

const THEME_KEY = 'asg.theme'

function loadTheme(): ThemeMode {
  try {
    const m = localStorage.getItem(THEME_KEY)
    if (m === 'dark' || m === 'light') return m
  } catch {
    /* ignore */
  }
  return 'light'
}

interface UiState {
  theme: ThemeMode
  /** 移动端抽屉导航 */
  drawerOpen: boolean
  /** 通知未读数（顶栏红点） */
  unreadNotifications: number
  /** 未读私信数 */
  unreadMessages: number
  setTheme: (t: ThemeMode) => void
  toggleTheme: () => void
  setDrawerOpen: (v: boolean) => void
  setUnreadNotifications: (n: number) => void
  setUnreadMessages: (n: number) => void
}

export const useUiStore = create<UiState>((set, get) => ({
  theme: loadTheme(),
  drawerOpen: false,
  unreadNotifications: 0,
  unreadMessages: 0,
  setTheme: (t) => {
    try {
      localStorage.setItem(THEME_KEY, t)
      document.documentElement.setAttribute('data-theme', t)
    } catch {
      /* ignore */
    }
    set({ theme: t })
  },
  toggleTheme: () => get().setTheme(get().theme === 'light' ? 'dark' : 'light'),
  setDrawerOpen: (v) => set({ drawerOpen: v }),
  setUnreadNotifications: (n) => set({ unreadNotifications: n }),
  setUnreadMessages: (n) => set({ unreadMessages: n }),
}))

export function initTheme() {
  const t = loadTheme()
  document.documentElement.setAttribute('data-theme', t)
}
